import React from 'react';
import useGlobalFlags from 'CustomHooks/useGlobalFlags';
import Typography from 'Components/Atoms/Typography';
import { FlagInput, FlagToggle, GlobalFlags, Section } from './index';

const GlobalFlagsTab: React.FC = () => {
  const globalFlags = useGlobalFlags();

  const ref = globalFlags.ref;
  const data = globalFlags?.data;

  const setFlag = (patch: Partial<GlobalFlags>) => {
    if (!ref) return;
    ref.set(patch, { merge: true });
  };

  return (
    <>
      <Typography
        variant="text-3"
        color="subdued"
        translation={null}
        block
        className="exp-flags__intro"
      >
        Diese Schalter wirken sich nicht nur auf das Dashboard aus, sondern auch
        auf das Reservierungs-Widget und auf die automatischen Emails.
      </Typography>

      <Section title="Reservierungen">
        <FlagToggle
          title="Gäste-Kommentar deaktivieren"
          description="Versteckt das Kommentar-Feld auf dem Widget sowie in den Eingabe-Formularen im Dashboard. Bestehende Kommentare bleiben sichtbar."
          checked={!!data?.deactivateGuestComment}
          onChange={(deactivateGuestComment) =>
            setFlag({ deactivateGuestComment })
          }
        />
      </Section>

      <Section title="Emails">
        <FlagToggle
          title="Erinnerungs-Email deaktivieren"
          description="Reservierungs-Erinnerungen werden nicht mehr versendet."
          checked={!!data?.deactivateReminderEmail}
          onChange={(deactivateReminderEmail) =>
            setFlag({ deactivateReminderEmail })
          }
        />
        <FlagToggle
          title="Feedback-/Follow-Up-Email deaktivieren"
          description="Die Email mit Feedback-Anfrage nach dem Besuch wird nicht mehr versendet."
          checked={!!data?.deactivateFeedbackEmail}
          onChange={(deactivateFeedbackEmail) =>
            setFlag({ deactivateFeedbackEmail })
          }
        />
      </Section>

      <Section title="Widget">
        <FlagInput
          title="Standard-Ländervorwahl im Telefonfeld"
          description="Wird im Telefonfeld des Reservierungs-Widgets als Vorbelegung verwendet. Beispiele: +49 (DE), +43 (AT), +41 (CH). Leer lassen für Standard (+49)."
          value={data?.phoneDefaultCountry ?? ''}
          onChange={(phoneDefaultCountry) => setFlag({ phoneDefaultCountry })}
        />
      </Section>
    </>
  );
};

export default GlobalFlagsTab;
